import { render, staticRenderFns } from "./ReceiverSettingsDetail.vue?vue&type=template&id=23b2a364&scoped=true&"
import script from "./ReceiverSettingsDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiverSettingsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverSettingsDetail.vue?vue&type=style&index=0&id=23b2a364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2a364",
  null
  
)

export default component.exports